/**
 * Resolve API base URL for local dev and production.
 * CRA reads REACT_APP_API_BASE_URL at build/start time.
 */
export function getApiBaseUrl() {
  let url = process.env.REACT_APP_API_BASE_URL?.trim();

  if (!url) {
    return 'http://127.0.0.1:8001';
  }

  // Fix typos like "https:host.com" -> "https://host.com"
  if (/^https?:[^/]/i.test(url)) {
    url = url.replace(/^(https?):/, '$1://');
  }

  // Invalid hostname without TLD (e.g. https://edupravahaa-tech-admin)
  if (/^https?:\/\/edupravahaa-tech-admin\/?$/i.test(url)) {
    return 'http://127.0.0.1:8001';
  }

  return url.replace(/\/$/, '');
}
